import { useEffect } from "react";
import { usePlatformWarnings } from "./usePlatformWarnings";
import { usePlatformNotificationsStore } from "@/store/platformNotificationsStore";

export const usePlatformNotifications = (): void => {
  const warnings = usePlatformWarnings();
  const setWarnings = usePlatformNotificationsStore((s) => s.setWarnings);

  useEffect(() => {
    setWarnings(warnings);
  }, [warnings, setWarnings]);
};
